import {GET_ACCOUNT_PLAN_SUMMARY} from "../actions/accountPlan.actions";

const initialState = {
	accountPlan: null,
};

export const accountPlanReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_ACCOUNT_PLAN_SUMMARY.SUCCESS:
			return {
				...state,
				accountPlan: action.payload
			};
		case GET_ACCOUNT_PLAN_SUMMARY.EMPTY:
			return {
				...state,
				accountPlan: null
			};
		default:
			return state;
	}
};
